export const notificationMessages = {
  "notifications.readingReminder.schedule": "It’s a good time to read.",
  "notifications.readingReminder.inactivity":
    "You have not logged reading for {days, plural, one {# day} other {# days}}.",
  "notifications.readingReminder.goalPacing":
    "Your {metric} goal is at {achieved} of {target}. A short reading session can help you catch up.",
  "notifications.actionFailed": "{action} action failed: {reason}",
  "notifications.bookOrganizationUpdated": "Book organization updated.",
  "notifications.bookRestored": "Book restored.",
  "notifications.bookUpdated": "Book updated.",
  "notifications.libraryUpdated": "Library updated.",
  "notifications.collectionRemoved": "Collection removed.",
  "notifications.collectionCreated": "Collection created.",
  "notifications.tagRemoved": "Tag removed.",
  "notifications.tagCreated": "Tag created.",
  "notifications.journalEntryUpdated": "Journal entry updated.",
  "notifications.journalEntrySaved": "Journal entry saved.",
  "notifications.readingProgressSaved": "Reading progress saved.",
  "notifications.readingSessionUpdated": "Reading session updated.",
  "notifications.readingSessionSaved": "Reading session saved.",
  "notifications.readingGoalUpdated": "Reading goal updated.",
  "notifications.readingGoalSaved": "Reading goal saved.",
  "notifications.profilePictureUploaded": "Profile picture uploaded.",
  "notifications.communityProfileUpdated": "Community profile updated.",
  "notifications.reviewUpdated": "Review updated.",
  "notifications.reviewSaved": "Review saved.",
  "notifications.communitySafetyUpdated": "Community safety preference updated.",
  "notifications.reportSubmitted": "Report submitted.",
  "notifications.clubJoined": "You joined the book club.",
  "notifications.clubCreated": "Book club created.",
  "notifications.challengeMembershipUpdated": "Challenge membership updated.",
  "notifications.notificationPreferencesUpdated": "Notification preferences updated.",
  "notifications.recommendationPreferencesUpdated":
    "Recommendation preferences updated.",
  "notifications.recommendationFeedbackSaved": "Recommendation feedback saved.",
  "notifications.importChoicesSaved": "Import choices saved.",
  "notifications.libraryImportCompleted": "Library import completed.",
  "notifications.libraryFileUploaded": "Library file uploaded.",
  "notifications.passwordUpdated": "Password updated.",
  "notifications.sessionRevoked": "Session access revoked.",
  "notifications.sessionsSignedOut": "All sessions signed out.",
  "notifications.profileUpdated": "Profile updated.",
  "notifications.bookAdded": "Book added to your library.",
  "notifications.bookRemoved": "Book removed.",
  "notifications.journalEntryRemoved": "Journal entry removed.",
  "notifications.reviewRemoved": "Review removed.",
} as const;
